import { render, staticRenderFns } from "./stock-class.vue?vue&type=template&id=d718e04a&scoped=true"
import script from "./stock-class.vue?vue&type=script&lang=js"
export * from "./stock-class.vue?vue&type=script&lang=js"
import style0 from "./stock-class.vue?vue&type=style&index=0&id=d718e04a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d718e04a",
  null
  
)

export default component.exports